import {List, ListItem} from '@luminopia/react-toolbox/lib/list'
import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {RouteComponentProps} from 'react-router'
import Card from 'study_coordinator/components/Card'
import {subjectShowRoute} from 'study_coordinator/routes'
import {getSubjectsRequest, IState} from 'study_coordinator/store'
import * as styles from './SubjectConfirmPage.css'

interface IRouteParams {
  subjectIdentifier: string
}
interface IStateProps {
  subjectIdentifier?: string
  accessCode?: string
  isFetching: boolean
  amblyopicEye?: string
}
interface IDispatchProps {
  onMount: () => void
}
interface IOwnProps extends RouteComponentProps<IRouteParams> {}
export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

class SubjectConfirmPage extends React.PureComponent<IProps, {}> {
  public render() {
    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    } else if (!this.props.isFetching && !this.props.subjectIdentifier) {
      return <h1>Patient not found</h1>
    }

    // TODO I18N
    return (
      <div>
        <Card title={`Patient ID`} subtitle={`${this.props.subjectIdentifier}`} icon='person_outline'>
        <List>
            <ListItem
              caption='The Access Code is'
              leftIcon='fingerprint'
              ripple={false}
            />
            <h1 className={styles.accessCode}>{this.props.accessCode}</h1>
            <ListItem
            caption='To treat Amblyopic Eye'
            leftIcon='medication'
            ripple={false}
            />
            <h1 className={styles.accessCode}>{this.props.amblyopicEye}</h1>
            <ListItem
              caption='Please record this Access Code in the Phil Pharmacy patient record, and provide to the patient.'
              leftIcon='checkmark'
              ripple={false}
            />
            <ListItem
              caption='See patient details'
              to={subjectShowRoute(this.props.subjectIdentifier)}
              ripple={false}
            />
          </List>
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    this.props.onMount()
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  const subject = state.subjects.items
    .find((item) => item.subjectIdentifier === ownProps.match.params.subjectIdentifier)
  if (!subject) return { isFetching: state.subjects.isFetching }
  return {
    subjectIdentifier: subject.subjectIdentifier,
    accessCode: subject.accessCode,
    amblyopicEye: subject.prescriptions[0].amblyopicEye,
    isFetching: state.subjects.isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>) => ({
  onMount: () => dispatch(getSubjectsRequest()),
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(SubjectConfirmPage)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/SubjectConfirmPage.tsx